  <!-- 用法
  <Dialog :visible="dialogVisible" :dialogTitle="'消息提示'" v-on:closeDialog="closeDialog" :width="'300px'">
    <div slot="dialog">
      <p>封装的组件</p> //写自己需要的内容
    </div>
  </Dialog>

  dialogVisible:传的Boolean值

   //关闭弹窗
   closeDialog(data) {
      console.log(data);
      this.dialogVisible = data;
    :modal-append-to-body="true"
    },
  -->

<template>
  <el-dialog :title="dialogTitle" :visible.sync="visible" :width="width" :show-close="showClose" @close="handleClose"
    :close-on-click-modal="false" :close-on-press-escape="false" :custom-class="'ContractBox'" ref="aaaa">
    <slot name="dialog-con"></slot>
    <slot slot="title" v-if="showSlotClose">
      <div class="title">
        <div class="title-text">{{ dialogTitle }}</div>
        <i class="el-icon-close" @click="handleSlotClose"></i>
      </div>
    </slot>
    <span slot="footer" class="dialog-footer">
      <slot name="dialog-btn"></slot>
    </span>
  </el-dialog>
</template> 

<script>
export default {
  props: {
    visible: Boolean,
    dialogTitle: String,
    width: String,
    showClose: {
      type: Boolean,
      default: true
    },
    showSlotClose: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    handleClose() {
      this.$emit("closeDialogfq", false);
    },

    handleSlotClose() {
      this.$emit("closeDialogSlotfq", false);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// .header {
//   width: 100%;
//   height: 40px;
//   background: #D81212;
//   text-align: center;
//   font-size: 16px;
//   color: #ffffff;
//   line-height: 40px;
//   border-radius: 5px 5px 0 0;
//   .el-icon-close {
//     float: right;
//     position: relative;
//     top: 12px;
//     right: 6px;
//   }
// }
</style>
<style lang="scss">
// .el-dialog {
//   border-radius: 5px;
// }
.el-dialog {
  border-radius: 5px;

}

.el-dialog__header {
  display: none;
}

.el-dialog__body {
  padding: 0px 0px;
  background-color: transparent;
  border-radius: 5px;
}

.el-dialog__headerbtn:focus .el-dialog__close,
.el-dialog__headerbtn:hover .el-dialog__close {
  color: #8C8C8C;
}

.el-dialog__headerbtn .el-dialog__close:hover {
  color: #D81212;
}

// .el-dialog__body {
//   padding: 0px 0px;
//   background-color: transparent;
//   border-radius: 5px;
// }

.subContract,
.closeContract {
  margin-top: 16px;
  width: 100%;
  height: 44px;
  background: #fff;
  border-radius: 4px;
  border-color: #D8D8D8;
  color: #595959;

  &:focus {
    background: #fff;
    color: #595959;
    border-color: #D8D8D8;
  }

  &:hover {
    background-color: #D81212;
    border: 1px solid #D81212;
    color: white;
  }
}

.subContract {
  background-color: #D81212;
  border: 1px solid #D81212;
  color: white;
}

.subContract:hover {
  background-color: #BB0C0C;
  border: 1px solid #BB0C0C;
}

.buttonActive {
  color: #D81212;
  border: 1px solid #D81212;
}

.title {
  display: flex;
  align-items: center;
  .title-text {
    flex: 1;
  }
  .el-icon-close {
    cursor: pointer;
  }
}
</style>
